export const INITIAL_STATE = {
    questions: [],
    hasMore: false,
    allowRequest: false,
    page: 1,
    showSkeleton: false,
    isSearch: false,
    scrollPosition: 0,
};

export function questionReducer(state, action) {
    switch (action.type) {
        case 'ADD_NEW':

            return {
                ...state,
                questions: action.payload.questions,
                hasMore: action.payload.hasMore,
                allowRequest: action.payload.allowRequest,
                page: action.payload.page,
                isSearch: action.payload.isSearch,
                showSkeleton: false,
            };

        case 'ADD_PREV':

            return {
                ...state,
                questions: [...state.questions, ...action.payload.questions],
                hasMore: action.payload.hasMore,
                allowRequest: action.payload.allowRequest,
                page: action.payload.page,
                showSkeleton: false,
                isSearch: false,
            };

        case 'SHOW_SKELETON':

            return {
                ...state,
                showSkeleton: action.payload.showSkeleton,
            };

        case 'STORE_SCROLL_POSITION':

            return {
                ...state,
                scrollYPosition: action.payload.scrollYPosition,
            }
    }
}